(function () {
  'use strict';

  const MODAL_ID = 'WholesaleQuoteModal';
  const optionAliases = {
    material: ['material', 'fabric', '材质', '面料'],
    color: ['color', 'colour', '颜色']
  };

  function getModal() { return document.getElementById(MODAL_ID); }
  function getProductData(modal) {
    const node = modal?.querySelector('[data-wholesale-product-json]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (_) { return null; }
  }
  function getVariantId(opener, data) {
    const section = opener.closest('.shopify-section');
    const input = section?.querySelector('form[action*="/cart/add"] [name="id"]');
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    return String(input?.value || urlVariant || data?.initialVariantId || '');
  }
  function findVariant(opener, data) {
    if (!data?.variants?.length) return null;
    const id = getVariantId(opener, data);
    return data.variants.find((variant) => String(variant.id) === id) || data.variants[0];
  }
  function optionIndex(names, configured, aliases) {
    const wanted = String(configured || '').trim().toLowerCase();
    let index = names.findIndex((name) => String(name).toLowerCase() === wanted);
    if (index >= 0) return index;
    return names.findIndex((name) => aliases.includes(String(name).trim().toLowerCase()));
  }
  function fallbackMaterialColor(data) {
    if (data?.fallbackMaterial || data?.fallbackColor) {
      return { material: data.fallbackMaterial || '', color: data.fallbackColor || '' };
    }
    const label = String(data?.productColorLabel || data?.productTitle || '').trim();
    const configuredColors = Array.isArray(data?.colorValues) ? data.colorValues : [];
    const colors = [...configuredColors, 'Black', 'Grey', 'Tan', 'Khaki', 'Charcoal', 'Classic']
      .filter(Boolean)
      .sort((a, b) => String(b).length - String(a).length);
    const color = colors.find((candidate) => label.toLowerCase().endsWith(String(candidate).toLowerCase()));
    if (!color) return { material: '', color: '' };
    return { material: label.slice(0, -String(color).length).trim(), color: String(color) };
  }
  function syncVariant(modal, opener) {
    const data = getProductData(modal);
    const variant = findVariant(opener, data);
    if (!variant) return;
    const materialIndex = optionIndex(data.optionNames || [], data.materialOptionName, optionAliases.material);
    const colorIndex = optionIndex(data.optionNames || [], data.colorOptionName, optionAliases.color);
    const fallback = fallbackMaterialColor(data);
    const setValue = (selector, value) => { const field = modal.querySelector(selector); if (field) field.value = value || ''; };
    setValue('[data-wholesale-material]', materialIndex >= 0 ? variant.options?.[materialIndex] : fallback.material);
    setValue('[data-wholesale-color]', colorIndex >= 0 ? variant.options?.[colorIndex] : fallback.color);
    setValue('[data-wholesale-variant-id]', variant.id);
    setValue('[data-wholesale-variant-title]', variant.title);
    setValue('[data-wholesale-sku]', variant.sku);
  }
  function focusable(modal) {
    return [...modal.querySelectorAll('button, input, textarea, select, [href], [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.disabled && element.offsetParent !== null);
  }
  function openModal(opener) {
    const modal = getModal();
    if (!modal) return;
    syncVariant(modal, opener);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('scroll-lock', '');
    modal._wholesaleOpener = opener;
    const first = focusable(modal)[0];
    if (first) window.requestAnimationFrame(() => first.focus());
  }
  function closeModal() {
    const modal = getModal();
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('scroll-lock');
    modal._wholesaleOpener?.focus();
  }
  function prepareForm(form) {
    const url = new URL(window.location.href);
    url.searchParams.set('quote_submitted', '1');
    const returnTo = form.querySelector('[name="return_to"]');
    if (returnTo) returnTo.value = `${url.pathname}${url.search}#${MODAL_ID}`;
    const submit = form.querySelector('.wholesale-quote-submit');
    if (submit) { submit.disabled = true; submit.setAttribute('aria-busy', 'true'); }
  }
  function init() {
    if (document.documentElement.dataset.wholesaleQuoteInitialized === 'true') return;
    document.documentElement.dataset.wholesaleQuoteInitialized = 'true';
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-wholesale-quote-open]');
      if (opener) { event.preventDefault(); openModal(opener); return; }
      if (event.target.closest('[data-wholesale-quote-close]')) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      const modal = getModal();
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
      if (event.key !== 'Tab') return;
      const items = focusable(modal);
      if (!items.length) return;
      const first = items[0]; const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('submit', (event) => {
      if (event.target.matches('.wholesale-quote-form')) prepareForm(event.target);
    });
    const params = new URLSearchParams(window.location.search);
    const modal = getModal();
    if (modal && (params.get('quote_submitted') === '1' || modal.querySelector('[data-wholesale-form-errors], [data-wholesale-form-success]'))) {
      const opener = document.querySelector('[data-wholesale-quote-open]');
      openModal(opener || modal);
      if (params.has('quote_submitted')) {
        params.delete('quote_submitted');
        const cleanUrl = `${window.location.pathname}${params.toString() ? `?${params}` : ''}${window.location.hash}`;
        window.history.replaceState({}, '', cleanUrl);
      }
    }
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
